import React from "react";
import { money } from "../lib/api";

const FLOW = [
  "ORDER RECEIVED", "PREORDER PENDING", "PREORDER CLOSED", "PRODUCTION PREPARATION",
  "IN PRODUCTION", "QUALITY CONTROL", "READY FOR FULFILLMENT", "READY TO SHIP",
  "SHIPPED", "COMPLETED",
];

export function OrderStatusTimeline({ status }) {
  const idx = FLOW.indexOf(status);
  return (
    <div className="space-y-0">
      {FLOW.map((s, i) => {
        const done = idx >= 0 && i <= idx;
        const current = i === idx;
        return (
          <div key={s} className="flex items-center gap-3 py-1.5">
            <div className={`h-3 w-3 rounded-full shrink-0 ${current ? "bg-yellow-400 ring-4 ring-yellow-400/20" : done ? "bg-emerald-500" : "bg-zinc-700"}`} />
            <span className={`font-mono text-xs uppercase tracking-wider ${current ? "text-yellow-400" : done ? "text-emerald-400" : "text-zinc-600"}`}>{s}</span>
          </div>
        );
      })}
    </div>
  );
}

export function OrderCard({ order }) {
  return (
    <div data-testid={`order-card-${order.order_number}`} className="bg-[#121216] border border-white/10 rounded-lg p-6">
      <div className="flex flex-wrap justify-between items-start gap-4 border-b border-white/10 pb-4 mb-4">
        <div>
          <p className="font-mono text-xs text-zinc-500 uppercase">{order.channel} Order</p>
          <p className="font-mono font-bold text-yellow-400 text-lg">{order.order_number}</p>
          <p className="text-xs text-zinc-500 mt-1">{order.academy_name} · {(order.created_at || "").slice(0, 10)}</p>
        </div>
        <div className="text-right">
          <span className="font-mono text-xs uppercase bg-white/5 border border-white/10 px-2 py-1 rounded text-emerald-400">{order.status}</span>
          <p className="font-mono font-bold text-white mt-2">{money(order.total)}</p>
        </div>
      </div>
      <div className="grid md:grid-cols-2 gap-6">
        <div className="space-y-2">
          {order.items?.map((it, i) => (
            <div key={i} className="text-sm">
              <span className="text-white">{it.product_name}</span>
              <span className="text-zinc-500 font-mono text-xs ml-2">
                {it.sizes?.map((s) => `${s.size}×${s.qty}`).join("  ")}
              </span>
            </div>
          ))}
        </div>
        <OrderStatusTimeline status={order.status} />
      </div>
    </div>
  );
}
